export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
    conditions() {
      return this.$store.state.news.conditions;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
    getPublication(id) {
      this.$store.dispatch('news/SetCondition', id);
      this.$router.push(`/condition/${id}`);
    },
  },
  created() {
    this.user.profile_id && this.$store.dispatch('news/GetConditions', this.user.profile_id);
  },
};
